// src/config/plotConfigs/codonOccupancyConfig.js
export const codonOccupancyDefaults = {
  groupType: "codon",
  plotType: "single",
  normType: "average_read_density",
  tranList: "",
  minRead: "20",
  maxRead: "35",
  xmin: "",
  xmax: "",
  ymin: "",
  ymax: "",
  cond1Name: "Group1",
  cond2Name: "Group2",
  emailNotification: false,
};

export const codonOccupancyValidation = {
  groupType: { required: true, label: "Group type" },
  plotType: { required: true, label: "Plot type" },
  normType: { required: true, label: "Normalisation type" },
  custom: (value, allSettings) => {
    if (allSettings.minRead && allSettings.maxRead) {
      const min = parseInt(allSettings.minRead);
      const max = parseInt(allSettings.maxRead);
      if (min >= max) {
        return "Min read length must be less than max read length";
      }
    }
    if (allSettings.xmin && allSettings.xmax) {
      const xmin = parseFloat(allSettings.xmin);
      const xmax = parseFloat(allSettings.xmax);
      if (xmin >= xmax) {
        return "X-axis min value must be less than max value";
      }
    }
    if (allSettings.ymin && allSettings.ymax) {
      const ymin = parseFloat(allSettings.ymin);
      const ymax = parseFloat(allSettings.ymax);
      if (ymin >= ymax) {
        return "Y-axis min value must be less than max value";
      }
    }
    return null;
  },
};

export const codonOccupancyConfig = {
  sections: [
    {
      fields: [
        {
          id: "groupType",
          label: "Group by",
          type: "radio",
          options: [
            {
              value: "codon",
              label: "Codon",
              tooltip: "Each codon will be plotted seperately.",
            },
            {
              value: "amino_acid",
              label: "Amino Acid",
              tooltip: "Codons are grouped by amino acid.",
            },
            {
              value: "diamino_acid",
              label: "Di-amino Acid",
              tooltip:
                "Each pair of amino acids will be plotted seperately, counts will be taken from both amino acids.",
            },
          ],
          width: 6,
        },
        {
          id: "normType",
          label: "Normalisation",
          type: "radio",
          options: [
            {
              value: "average_read_density",
              label: "Average read density",
              tooltip:
                "Each read is normalised by the average read count for that transcript, then normalised by the total number of codons/amino acids of that type present in the CDS of all transcripts.",
            },
            {
              value: "none",
              label: "Codon/Amino acid count only",
              tooltip:
                "Reads are only normalised by the codon/amino acid count.",
            },
          ],
          width: 6,
        },
        {
          id: "tranList",
          label: "Transcript list (Optional)",
          type: "textarea",
          placeholder: "Enter transcript IDs (one per line)",
          tooltip:
            "Optionally enter a comma separated list of transcript IDs to only carry out the analysis on these transcripts.",
          width: 6,
          rows: 3,
        },
        {
          id: "minRead",
          label: "Min read length",
          type: "number",
          placeholder: "Enter minimum read length",
          min: 1,
          tooltip:
            "The shortest read length used to calculate the counts (inclusive).",
          width: 3,
        },
        {
          id: "maxRead",
          label: "Max read length",
          type: "number",
          placeholder: "Enter maximum read length",
          min: 1,
          tooltip:
            "The longest read length used to calculate the counts (inclusive).",
          width: 3,
        },
        {
          id: "xmin",
          label: "X-axis min",
          type: "number",
          placeholder: "X minimum",
          tooltip:
            "Optionally manually set the x-axis scale of the plot, if left empty scaling will be automatic, values can be positive or negative. Only applies to comparison plots, note that the values on the comparison plot are log2 values.",
          width: 3,
        },
        {
          id: "xmax",
          label: "X-axis max",
          type: "number",
          placeholder: "X maximum",
          tooltip:
            "Optionally manually set the x-axis scale of the plot, if left empty scaling will be automatic, values can be positive or negative. Only applies to comparison plots, note that the values on the comparison plot are log2 values.",
          width: 3,
        },
        {
          id: "ymin",
          label: "Y-axis min",
          type: "number",
          placeholder: "Y minimum",
          tooltip:
            "Optionally manually set y-axis scale of the plot, if left empty scaling will be automatic, values can be positive or negative.Applies to both single and comparison plots, note that the values on the comparison plot are log2 values.",
          width: 3,
        },
        {
          id: "ymax",
          label: "Y-axis max",
          type: "number",
          placeholder: "Y maximum",
          tooltip:
            "Optionally manually set y-axis scale of the plot, if left empty scaling will be automatic, values can be positive or negative.Applies to both single and comparison plots, note that the values on the comparison plot are log2 values.",
          width: 3,
        },
        {
          id: "emailNotification",
          label: "Email notification",
          type: "checkbox",
          tooltip:
            "If checked an email notification will be sent to you once the job has completed. The email will contain a link to the results of this job.",
          width: 6,
        },
      ],
    },
  ],
};
